import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail } from "lucide-react";
import { CrestLogo } from "../components/CrestLogo";

export default function Privacy() {
  return (
    <div className="bg-[#F7F5F2] min-h-screen flex flex-col selection:bg-[#1F3A33] selection:text-[#F7F5F2]">
      {/* Floating Header */}
      <header className="backdrop-blur-xl bg-[#F7F5F2]/80 border-b border-[#1F3A33]/10 h-20 flex items-center">
        <div className="max-w-7xl mx-auto px-6 md:px-12 w-full flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <CrestLogo variant="dark" className="w-10 h-10" />
            <span className="font-serif tracking-[0.15em] text-base md:text-lg font-light text-[#1F3A33] uppercase">
              The Catalyst Table
            </span>
          </Link>
          <Link 
            to="/" 
            className="flex items-center gap-2 text-xs font-semibold tracking-widest text-[#1F3A33] uppercase hover:text-[#C8A97E] transition-colors"
          >
            <ArrowLeft className="w-4 h-4" /> Back to Invitation
          </Link>
        </div>
      </header>

      {/* Content Container */}
      <main className="flex-grow py-24 md:py-32">
        <div className="max-w-3xl mx-auto px-6 md:px-12 text-left space-y-12">
          
          {/* Header Title */}
          <div className="space-y-4">
            <span className="uppercase text-xs tracking-[0.25em] font-semibold text-[#8B6A4E] block">
              Regulatory Compliance
            </span>
            <h1 className="text-4xl md:text-5xl font-light text-[#1F3A33]">
              Privacy Policy
            </h1>
            <div className="w-12 h-[1px] bg-[#C8A97E]"></div>
          </div>

          {/* Main Editorial Text */}
          <div className="font-sans font-light text-base md:text-lg text-[#2E2E2E] space-y-8 leading-relaxed">
            
            {/* Section 1 */}
            <section className="space-y-4">
              <h2 className="font-serif text-2xl font-light text-[#1F3A33]">
                Who we are
              </h2>
              <p>
                The Catalyst Table is a curated dinner community that brings women together for meaningful conversations, connections and opportunities.
              </p>
            </section>

            {/* Section 2 */}
            <section className="space-y-4">
              <h2 className="font-serif text-2xl font-light text-[#1F3A33]">
                What information we collect
              </h2>
              <p>We may collect:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Name</li>
                <li>Email address</li>
                <li>Organisation</li>
                <li>Professional role</li>
                <li>LinkedIn profile</li>
                <li>Information provided through forms and nominations</li>
                <li>Website analytics and cookies</li>
              </ul>
            </section>

            {/* Section 3 */}
            <section className="space-y-4">
              <h2 className="font-serif text-2xl font-light text-[#1F3A33]">
                Why we collect it
              </h2>
              <p>We collect this information to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>respond to enquiries;</li>
                <li>manage our waiting list;</li>
                <li>organise events and invitations;</li>
                <li>facilitate introductions and nominations;</li>
                <li>communicate with members of our community.</li>
              </ul>
            </section>

            {/* Section 4 */}
            <section className="space-y-4">
              <h2 className="font-serif text-2xl font-light text-[#1F3A33]">
                Legal basis for processing
              </h2>
              <p>We process personal data on the basis of:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>consent;</li>
                <li>legitimate interests in managing our community.</li>
              </ul>
            </section>

            {/* Section 5 */}
            <section className="space-y-4">
              <h2 className="font-serif text-2xl font-light text-[#1F3A33]">
                How long we keep your information
              </h2>
              <p>
                We only retain personal information for as long as necessary to fulfil the purposes for which it was collected.
              </p>
            </section>

            {/* Section 6 */}
            <section className="space-y-4">
              <h2 className="font-serif text-2xl font-light text-[#1F3A33]">
                Your rights
              </h2>
              <p>Under UK GDPR, you have the right to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>access your information;</li>
                <li>correct inaccurate information;</li>
                <li>request deletion;</li>
                <li>withdraw consent;</li>
                <li>object to processing;</li>
                <li>lodge a complaint with the Information Commissioner’s Office (ICO).</li>
              </ul>
            </section>

            {/* Section 7 */}
            <section className="space-y-4 p-8 border border-[#1F3A33]/15 bg-[#1F3A33]/5">
              <h2 className="font-serif text-2xl font-light text-[#1F3A33]">
                Contact us
              </h2>
              <p>
                If you have any questions regarding this policy or your personal information, please contact:
              </p>
              <a 
                href="mailto:hello@thecatalysttable.com" 
                className="inline-flex items-center gap-2 font-medium text-[#1F3A33] hover:text-[#C8A97E] transition-colors"
              >
                <Mail className="w-4 h-4 text-[#C8A97E]" /> hello@thecatalysttable.com
              </a>
            </section>

          </div>

          {/* Button back to Home */}
          <div className="pt-8 border-t border-[#1F3A33]/10">
            <Link 
              to="/" 
              className="inline-block bg-[#1F3A33] text-[#F7F5F2] uppercase text-xs font-semibold tracking-[0.2em] px-8 py-4 hover:bg-[#2E2E2E] transition-colors"
            >
              Return To Invitation
            </Link>
          </div>

        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#1F3A33] text-[#F7F5F2] py-8 border-t border-[#C8A97E]/20 text-center text-xs">
        <p>© {new Date().getFullYear()} The Catalyst Table. All rights reserved.</p>
      </footer>
    </div>
  );
}
